export default {
  data() {
    //客户级别
    const level = [
      {
        value: 1,
        label: 'AAA',
      },
      {
        value: 2,
        label: 'AA+',
      },
      {
        value: 3,
        label: 'AA',
      },
      {
        value: 4,
        label: 'AA-',
      },
      {
        value: 5,
        label: 'A+',
      },
      {
        value: 6,
        label: 'A',
      },
      {
        value: 7,
        label: 'A-',
      },
      {
        value: 8,
        label: 'BBB',
      },
      {
        value: 9,
        label: 'BB',
      },
      {
        value: 10,
        label: 'B',
      },
    ]
    return {
      //企业额外信息
      EXTRA_INFO_SCHEMA: {
        shareholderNature: {
          label: '股东性质',
          type: 'select',
          disabled: true,
          optionList: [
            {
              value: 1,
              label: '上市公司',
            },
            {
              value: 2,
              label: '央企、国企',
            },
            {
              value: 3,
              label: '股份有限公司',
            },
            {
              value: 4,
              label: '有限责任公司',
            },
            {
              value: 5,
              label: '其他（私人等）',
            },
          ],
        },
        lastRefundAvgDays: {
          label: '上财年加权平均回款天数',
          type: 'input',
          handleInputCheck: 'checkPositiveInt',
          disabled: true,
        },
        lastExpiryTimes: {
          label: '上财年逾期次数',
          handleInputCheck: 'checkPositiveInt',
          type: 'input',
          disabled: true,
        },
        lastExpiryRate: {
          label: '上财年3天以上逾期率(%)',
          handleInputCheck: 'checkFloat2',
          type: 'input',
          disabled: true,
        },
        expiryAvgDays: {
          label: '近三财年加权平均逾期天数',
          handleInputCheck: 'checkPositiveInt',
          type: 'input',
          disabled: true,
        },
        expiryAvgRate: {
          label: '近三财年3天以上逾期率(%)',
          handleInputCheck: 'checkFloat2',
          type: 'input',
          disabled: true,
        },
        isExpiryRisk: {
          label: '上财年是否出现真实逾期风险',
          type: 'select',
          optionList: [
            {
              label: '否',
              value: '2',
            },
            {
              label: '是',
              value: '1',
            },
            {
              label: '新客户',
              value: '3',
            },
          ],
          disabled: true,
        },
        isExpiry: {
          label: '目前是否存在真实逾期',
          type: 'select',
          optionList: [
            {
              label: '否',
              value: '2',
            },
            {
              label: '是',
              value: '1',
            },
            {
              label: '新客户',
              value: '3',
            },
          ],
          disabled: true,
        },
        purchase: {
          label: '近三年进货额(元)',
          handleInputCheck: 'checkFloat2',
          type: 'input',
          disabled: true,
        },
        purchasePlan: {
          label: '未来一年联想直接采购预估额(元)',
          handleInputCheck: 'checkFloat2',
          type: 'input',
          disabled: true,
        },
        purchaseRateIncrement: {
          label: '联想直接采购额年增长率(%)',
          handleInputCheck: 'checkFloat2',
          type: 'input',
          disabled: true,
        },
        level: {
          label: '客户级别',
          type: 'select',
          optionList: level,
          disabled: true,
        },
        industryLevel: {
          label: '行业风险级别',
          type: 'select',
          optionList: [
            {
              label: '绿色',
              value: 1,
            },
            {
              label: '黄色',
              value: 2,
            },
            {
              label: '红色',
              value: 3,
            },
          ],
          disabled: true,
        },
        regionLevel: {
          label: '地域风险级别',
          type: 'select',
          optionList: [
            {
              label: '绿色',
              value: 1,
            },
            {
              label: '黄色',
              value: 2,
            },
            {
              label: '红色',
              value: 3,
            },
          ],
          disabled: true,
        },
        actualReceipt: {
          label: '实收资本(元)',
          handleInputCheck: 'checkFloat2',
          type: 'input',
          disabled: true,
        },
        subjectiveEvaluation: {
          label: '主观评价',
          type: 'input',
          handleInputCheck: 'checkFloat2',
          placeholder: '请输入数字',
          rules: [{ required: true, message: '请选择主观评价' }],
          disabled: true,
        },
        establishYear: {
          label: '成立年限',
          disabled: true,
          type: 'input',
        },
        coopTime: {
          label: '合作年限',
          type: 'select',
          disabled: true,
          optionList: [],
        },
      },
      labelCol: {
        xs: { span: 9 },
      },
      wrapperCol: {
        xs: { span: 14 },
      },
      //企业额外信息-数据
      sourceDataExtra: {
        companyCode: '',
        shareholder: '',
        shareholderCard: '',
        shareholderNature: '',
        lastRefundAvgDays: '',
        lastExpiryTimes: '',
        lastExpiryRate: '',
        expiryAvgDays: '',
        expiryAvgRate: '',
        isExpiryRisk: '',
        isExpiry: '',
        purchasePlan: '',
        purchase: '',
        purchaseRateIncrement: '',
        level: '',
        industryLevel: '',
        regionLevel: '',
        establishYear: '',
        coopTime: '',
        actualReceipt: '',
        subjectiveEvaluation: '',
      },
      formLayout: 'horizontal',
      labelColExtra: {
        xs: { span: 13 },
      },
      wrapperColExtra: {
        xs: { span: 10 },
      },
    }
  },
}
